import { useSelector } from 'react-redux'
import type { RootState } from '../store'
import { useExperimentalFlag } from './useExperimentalFlag'
import { useGetPlaywrightAnalysesQuery } from '../services/projectDataApi'

export function usePlaywrightTestsEnabled(projectId: string) {
  const user = useSelector((s: RootState) => s.auth.user)
  const { enabled } = useExperimentalFlag('playwright_tests')
  // Failure analyses live on the token/session-gated v1 API, and the browser holds no Authorization
  // credential — a signed-out visitor has no session cookie either, so every poll it sends is a
  // doomed 401. Skip while signed out, the same rule useExperimentalFlag applies to the settings
  // request.
  const analyses = useGetPlaywrightAnalysesQuery({ projectId, limit: 1 }, {
    skip: !projectId || !user,
    pollingInterval: 15_000,
    skipPollingIfUnfocused: true,
  })
  return enabled || (analyses.currentData?.total ?? 0) > 0
}
